import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import EmailGate from "./pages/EmailGate";
import ChatPage from "./pages/ChatPage";
import OrderSuccess from "./pages/OrderSuccess";
import AdminPanel from "./pages/AdminPanel";
import JobTicket from "./pages/JobTicket";
import MaterialLibrary from "./pages/MaterialLibrary";
import Portfolio from "./pages/Portfolio";
import PortfolioIndustry from "./pages/PortfolioIndustry";
import PortfolioProduct from "./pages/PortfolioProduct";
import PortfolioProject from "./pages/PortfolioProject";
import Kiosk from "./pages/Kiosk";
import { getSession } from "./lib/session";

const RequireSession = ({ children }) => {
  const s = getSession();
  if (!s || !s.session_id) return <Navigate to="/" replace />;
  return children;
};

function App() {
  useEffect(() => {
    document.title = "Quote System | Roswell Print Center";
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EmailGate />} />
          <Route
            path="/chat"
            element={
              <RequireSession>
                <ChatPage />
              </RequireSession>
            }
          />
          <Route
            path="/order/success/:orderId"
            element={
              <RequireSession>
                <OrderSuccess />
              </RequireSession>
            }
          />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/jobs/:id/ticket" element={<JobTicket />} />
          <Route path="/materials" element={<MaterialLibrary />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/product/:slug" element={<PortfolioProduct />} />
          <Route path="/portfolio/project/:id" element={<PortfolioProject />} />
          <Route path="/portfolio/:slug" element={<PortfolioIndustry />} />
          <Route path="/kiosk/:storeId" element={<Kiosk />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1C1917",
            color: "#FAFAF9",
            border: "2px solid #FFB500",
            borderRadius: "4px",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
